import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["value"]
const _hoisted_2 = { class: "columns strat1 s-card is-mobile mx-0 my-5" }
const _hoisted_3 = { class: "column strat1" }
const _hoisted_4 = { class: "flex-table" }
const _hoisted_5 = { class: "flex-table-header" }
const _hoisted_6 = { style: {"color":"#a9abac","font-weight":"bold"} }
const _hoisted_7 = { class: "flex-list-inner" }
const _hoisted_8 = { class: "flex-table-cell" }
const _hoisted_9 = { class: "column strat1" }
const _hoisted_10 = { class: "flex-table" }
const _hoisted_11 = { class: "flex-list-inner" }
const _hoisted_12 = {
  class: "flex-table-cell cell-end",
  "data-th": ""
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_draggable = _resolveComponent("draggable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[8] || (_cache[8] = _createElementVNode("label", { class: "label" }, "User", -1)),
    (_ctx.user.is_staff==true)
      ? (_openBlock(), _createElementBlock("p", {
          key: 0,
          class: _normalizeClass(_ctx.select)
        }, [
          _createElementVNode("select", {
            class: "select",
            name: "creator",
            onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.fieldUpdate && _ctx.fieldUpdate(...args)))
          }, [
            _cache[2] || (_cache[2] = _createElementVNode("option", { value: "0" }, "Please select...", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.all_groups, (group_data) => {
              return (_openBlock(), _createElementBlock("option", {
                key: group_data.id,
                value: group_data.id
              }, _toDisplayString(group_data.name), 9, _hoisted_1))
            }), 128))
          ], 32)
        ], 2))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[3] || (_cache[3] = _createElementVNode("span", null, "Group ", -1)),
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.group_data.name), 1),
            _cache[4] || (_cache[4] = _createElementVNode("span", { class: "cell-end" }, [
              _createTextVNode("Drag to right "),
              _createElementVNode("i", {
                "aria-hidden": "true",
                class: "lnir lnir-shift-right"
              })
            ], -1))
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", null, [
              _createVNode(_component_draggable, {
                ref: "AddtoList",
                style: {"width":"100%"},
                class: "dragArea list-group w-full",
                list: _ctx.AllStratsP,
                group: "stratsp"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.AllStratsP, (element) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: element.strat_name,
                      class: "flex-table-item dragmove has-background-link"
                    }, [
                      _createElementVNode("div", _hoisted_8, _toDisplayString(element.strat_name), 1),
                      _cache[5] || (_cache[5] = _createElementVNode("div", {
                        class: "flex-table-cell cell-end",
                        "data-th": ""
                      }, [
                        _createElementVNode("i", {
                          "aria-hidden": "true",
                          class: "lnir lnir-shift-right"
                        })
                      ], -1))
                    ]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["list"])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "flex-table-header" }, [
            _createElementVNode("span", null, [
              _createElementVNode("i", {
                "aria-hidden": "true",
                class: "lnir lnir-shift-left"
              }),
              _createTextVNode(" Drag to left")
            ]),
            _createElementVNode("span", { class: "cell-end" }, "Custom Strats ")
          ], -1)),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", null, [
              _createVNode(_component_draggable, {
                class: "dragArea list-group w-full",
                list: _ctx.CustomStratListP,
                group: "stratsp",
                onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.statusChangeStrat('added', 3)))
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.CustomStratListP, (element) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: element.strat_name,
                      class: "flex-table-item dragmove has-background-info"
                    }, [
                      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "flex-table-cell" }, [
                        _createElementVNode("i", {
                          "aria-hidden": "true",
                          class: "lnir lnir-shift-left"
                        })
                      ], -1)),
                      _createElementVNode("div", _hoisted_12, _toDisplayString(element.strat_name), 1)
                    ]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["list"])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}